<template>
    <vue-scroll>
        <div class="page-header">
            <h1>{{ community.name }}</h1>
        </div>
        <div v-loading="loading">
            <div class="header-with-line">
                <i class="mdi mdi-laptop-chromebook dd mr-10"></i>
                <h2>Calendars for Digital Display</h2>
                <div class="line"></div>
            </div>
            <el-table
                class="mt-20 el-table--no-border el-table--no-header"
                :data="community.locations.data"
            >
                <el-table-column
                    prop="name"
                    label="Calendar Name"
                    width="250px"
                />
                <el-table-column
                    prop="digital_display"
                    label="Digital Display"
                    width="100px"
                    align="right"
                >
                    <template slot-scope="{ row }">
                        <p v-if="row.dd_client" class="corwin-text">Active</p>
                        <p v-else class="disabled-text">Inactive</p>
                    </template>
                </el-table-column>
                <el-table-column prop="visibility" width="100px">
                    <template slot-scope="{ row }">
                        <el-switch
                            v-model="row.dd_client"
                            v-if="row.dd_url && row.dd_admin"
                            @change="updateVisibility(row)"
                            class="“no-pointer-events”"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="actions">
                    <template slot-scope="{ row }">
                        <div v-if="row.dd_url">
                            <p>
                                Public URL:
                                <span
                                    @click="copyLink"
                                    class="cursor-pointer"
                                    >{{ row.dd_url }}</span
                                >
                            </p>
                            <input
                                type="hidden"
                                id="copy-link"
                                :value="row.dd_url"
                            />
                        </div>
                        <el-button
                            type="danger"
                            round
                            @click="signup(row)"
                            :disabled="signupStatus(row)"
                            v-else
                            >Signup</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as Actions from "@/store/constants/actions";

export default {
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState(["current_community"]),
        // community () {
        //     // console.log(this)
        //     // return this.$store.state.current_community;
        //     return [ ...this.$store.state.current_community ]
        // }
        ...mapState({
            community: (state) => _.cloneDeep(state.current_community),
        }),
    },
    methods: {
        signup(location) {
            this.loading = true;
            axios
                .post(`/web-api/location/${location.id}/signup-dd`)
                .then((response) => {
                    this.$store.dispatch(Actions.FETCH_CURRENT_COMMUNITY);
                })
                .finally(() => (this.loading = false));
        },
        signupStatus(location) {
            if (location.signup_at) {
                return true;
            } else {
                return false;
            }
        },
        updateVisibility(location) {
            this.loading = true;
            axios
                .post(`/web-api/location/${location.id}/update-dd-visibility`, {
                    value: location.dd_client,
                })
                .then((response) => {
                    this.$store.dispatch(Actions.FETCH_CURRENT_COMMUNITY);
                    this.$notify.success({
                        message: `Changes have been saved.`,
                    });
                })
                .finally(() => (this.loading = false));
        },
        copyLink() {
            let copyLinkToProduct = document.querySelector("#copy-link");
            copyLinkToProduct.setAttribute("type", "text");
            copyLinkToProduct.select();
            try {
                var successful = document.execCommand("copy");
                var msg = successful ? "successful" : "unsuccessful";
                this.$message({
                    message: "Link copied to clipboard.",
                    type: "success",
                });
            } catch (err) {
                alert("Oops, unable to copy");
            }
            copyLinkToProduct.setAttribute("type", "hidden");
            window.getSelection().removeAllRanges();
        },
    },
};
</script>

<style scoped>
.mdi-laptop-chromebook.dd {
    background-color: #54b6e7;
    color: #fff;
    padding: 1px 10px;
    border-radius: 25px;
    font-size: 30px;
    line-height: 46px;
}
.corwin-text {
    color: #90bb3f;
}
.disabled-text {
    opacity: 0.8;
}
</style>
